import axios from 'axios';
import {getAxios} from './axiosUtil';
import {getAuthAppBaseUrl} from '../util/AppUtil';

export const checkIfUserIsRegisteredApi = (email) => {
    const param = {
        params: {
            email
        }
    }

    return getAxios().get(`${getAuthAppBaseUrl()}/user/is_registered`, param);
}

export const signUpApi = (service, fullname, email, country, password, invited) => {
    let data = {
        service,
        fullname,
        email,
        country,
        password,
        invited
    }

    return getAxios().post(`${getAuthAppBaseUrl()}/user/register`, data);
}

export const mainAppSignUpApi = (firstname, lastname, email, country, state, password, id) => {
    let data = {
        firstname,
        lastname,
        email,
        country, 
        state,
        password,
        id
    }
    return getAxios().post(`${process.env.REACT_APP_MAIN_APP_BASE_URL}/signup`, data);
}

export const invoiceAppSignUpApi = (firstname, lastname, email, country, state, password, id) => {
    let data = {
        firstname,
        lastname,
        email,
        country,
        state,
        password, 
        id

    }
    return getAxios().post(`${process.env.REACT_APP_INVOICE_APP_BASE_URL}/user/register`, data);
}

export const signInApi = (email, password, service, env) => {
    let data = {
        email,
        password,
        service,
        env
    }
    return getAxios().post(`${getAuthAppBaseUrl()}/user/login`, data)
}

export const getRedirectUrlApi = (service) => {
    const param = {
        params: {
            service
        }
    }
    return getAxios().get(`${getAuthAppBaseUrl()}/user/me`, param);
}

export const publishUserApi = (access_token) => {
    getAxios().defaults.headers.common['Authorization'] = access_token;
    return getAxios().post(`${getAuthAppBaseUrl()}/user/publish_user`);
}

export const logoutApi = (access_token) => {
    getAxios().defaults.headers.common['Authorization'] = access_token;
    return getAxios().post(`${getAuthAppBaseUrl()}/logout`);
}

export const forgotPasswordApi = (email, service) => {
    let data = {
        email,
        service
    }
    return getAxios().post(`${getAuthAppBaseUrl()}/user/forgot_password`, data)
}

export const updatePasswordApi = (password, jwt) => {
    let data = {
        password
    }

    getAxios().defaults.headers.common['Authorization'] = jwt;
    return getAxios().post(`${getAuthAppBaseUrl()}/user/update_password`, data)
}

export const getAllAppsApi = () => {
    return getAxios().get(`${getAuthAppBaseUrl()}/apps`)
}

export const getAllAppsWithAccessTokenApi = (access_token) => {
    getAxios().defaults.headers.common['Authorization'] = access_token;
    return getAxios().get(`${getAuthAppBaseUrl()}/apps`)
}

export const checkServiceNameApi = (service) => {
    const param = {
        params : {
            service
        }
    }
    return getAxios().get(`${getAuthAppBaseUrl()}/app/validate`, param)
}

export const eprocessifyAppsActivationApi = (access_token, apiBaseUrl, service, email, firstname, lastname, country, role, invited, registered, entity_id) => {
    let data = {
        service,
        email,
        firstname, 
        lastname,
        country,
        role,
        invited,
        registered,
        entity_id
    }
    if(access_token) {
        getAxios().defaults.headers['Authorization'] = access_token;
    }
    return getAxios().post(`${apiBaseUrl}/user/activation`, data)
}

export const registerScopeApi = (service) => {
    let data = {
        service
    }
    return getAxios().put(`${getAuthAppBaseUrl()}/user/register_scope`, data)
}

export const resendActivationApi = (service, email) => {
    let data = {
        service,
        email
    }
    return getAxios().post(`${getAuthAppBaseUrl()}/user/resend_activation`, data)
}

export const getCountryApi = (token) => {
    return getAxios().get(` https://ipinfo.io/json?token=${token}`)
}

export const authenticateApi = (service) => {
    const param = {
        params: {
            service
        }
    }
    return getAxios().get(`${getAuthAppBaseUrl()}/authenticate`, param)
}

export const getAccessTokenApi = (access_token, env) => {
    let data = {
        env
    }
    getAxios().defaults.headers.common['Authorization'] = access_token;
    return getAxios().post(`${getAuthAppBaseUrl()}/user/set_token`, data)
}